<div class="content">
  <mat-tab-group mat-align-tabs="center" [selectedIndex]="data?.selectedTabIndex">
    <mat-tab label="Detalhes da Posição">
      <app-pigeonhole-details
        [group]="pigeonholeDetails?.group"
        [position]="pigeonholeDetails">
      </app-pigeonhole-details>
    </mat-tab>
    <mat-tab label="Pallets ({{packages.length}})">
      <app-package-list-details 
        [packages]="packages"
        (goToPalletDetails)="openPalletDetails($event)"
        [palletToScrollTo]="data?.scrollTo">
      </app-package-list-details>
    </mat-tab>
  </mat-tab-group>
</div>
